














































































































































































// import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';
import { tooltip } from '@libs-uuif/shared/tooltip-dir';
import { SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { MsspModalObject, CountryListType, StateListType, MsspModalObjectAddApi, MsspModalObjectEditApi, MSSPDetailsApiResponse } from '../types';
import { stateList } from '../stateList.data';
import  { MswApiService } from '@/shared/msw-api-service';
import { AddressFormObjType } from '../../../shared/address-verification-component/types';
import AddressVerificationComponent from '../../../shared/address-verification-component/address-verification-component.vue';
import RegexValidators from '../../../shared/regex-validators';

const cssPrefix = 'add-mssp-modal';
@Component({
  components: {
    ...UUIFComponents,
    AddressVerificationComponent,
  }, directives: {
    tooltip,
  },
})
export default class AddMsspModal extends SwExtendedVue {

  @Prop({ type: String })
  modalMode: string;

  @Prop()
  msspList: SelectOption[];

  cssPrefix = cssPrefix;
  msspModalObject:MsspModalObject = {
    MSSPname: '',
    emailAddress: '',
    contactName: '',
    companyName: '',
    phoneNumber: '',
    streetAddress: '',
    city: '',
    country: 'US',
    state: '',
    zipCode: '',
    isDefaultGroup: 'YES',
    MSSPID: '',
    additionalComments: '',
    province: '',
    firstName: '',
    lastName: '',
    msspNumber: '',
    msspContractid: '',
  };
  addressVerificationNeeded: string = '';
  enableAddressVerificationFormModal: boolean = false;
  addressFormSuggestedObj:AddressFormObjType = {
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
    country: '',
    city: '',
    postalCode: '',
    state: '',
    province: '',
    countryLabel: '',
    stateLabel: '',
  };
  addressFormAppliedObj:AddressFormObjType = {
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
    country: '',
    city: '',
    postalCode: '',
    state: '',
    province: '',
    countryLabel: '',
    stateLabel: '',
  };
  addressType = '';
  addressVerificationEnabled: boolean = false;
  showErrorMsg = false;
  inValidEmail: boolean = false;
  inValidPhone: boolean = false;
  countryList = [];
  addressVerificationMsg = '';
  msspDuplicateShowError = false;
  apiFailedAddressVerificationMesssage = '';

  onMsspInput(type: string) {
    switch (type) {
      case'MSSPname':
        this.msspModalObject.MSSPname = this.msspModalObject.MSSPname.trim();
        this.msspDuplicateShowError = false;
        this.fetchMsspFlag(this.msspModalObject.MSSPname);
        break;
      case'emailAddress':
        this.msspModalObject.emailAddress = this.msspModalObject.emailAddress.trim();
        break;
      case'firstName':
        this.msspModalObject.firstName = this.msspModalObject.firstName.trim();
        break;
      case'lastName':
        this.msspModalObject.lastName = this.msspModalObject.lastName.trim();
        break;
      case'msspNumber':
        this.msspModalObject.msspNumber = this.msspModalObject.msspNumber.trim();
        break;
      case'msspContractid':
        this.msspModalObject.msspContractid = this.msspModalObject.msspContractid.trim();
        break;
      case'companyName':
        this.msspModalObject.companyName = this.msspModalObject.companyName.trim();
        break;
      case'phoneNumber':
        this.msspModalObject.phoneNumber = this.msspModalObject.phoneNumber.trim();
        break;
      case'streetAddress':
        this.msspModalObject.streetAddress = this.msspModalObject.streetAddress.trim();
        break;
      case'city':
        this.msspModalObject.city = this.msspModalObject.city.trim();
        break;
      case'country':
        this.msspModalObject.country = this.msspModalObject.country.trim();
        break;
      case'state':
        this.msspModalObject.state = this.msspModalObject.state.trim();
        break;
      case'province':
        this.msspModalObject.province = this.msspModalObject.province.trim();
        break;
      case'zipCode':
        this.msspModalObject.zipCode = this.msspModalObject.zipCode.trim();
        break;
    }
  }
  get getDefaultUserGroup() {
    return this.msspModalObject.isDefaultGroup === 'YES';
  }

  onUserGroupChange(value: boolean) {
    if (value) {
      this.msspModalObject.isDefaultGroup = 'YES';
    } else {
      this.msspModalObject.isDefaultGroup = 'NO';
    }
  }
  get stateOptions(): SelectOption[] {
    const filterStateOption: SelectOption[] = [];
    stateList.map((ele: StateListType) => {
      if (this.msspModalObject.country === ele.country) {
        filterStateOption.push({
          id: ele.id,
          label: ele.label,
          value: ele.id,
        });
      }
    });
    return filterStateOption;
  }

  get countryOptions(): SelectOption[] {
    return this.countryList.map((list: CountryListType) => {
      return {
        id: list.countryCode,
        value: list.countryCode,
        label: list.countryName,
      };
    });
  }

  onCancel() {
    this.$emit('oncloseMsspModal');
  }

  checkEmail() {
    const regexStr =  new RegExp(RegexValidators.email);
    this.inValidEmail = !regexStr.test(this.msspModalObject.emailAddress);
  }

  checkPhone() {
    const regexStr = new RegExp(RegexValidators.phoneNo);
    this.inValidPhone = !regexStr.test(this.msspModalObject.phoneNumber);
  }

  fetchMsspFlag(msspName: string) {
    const index = this.msspList.findIndex((ele: SelectOption) => ele.label === msspName);
    if (index !== -1) {
      this.msspDuplicateShowError = true;
      return true;
    }
    return false;
  }
  get getValidationFlag() {
    let flag = false;
    const msspDuplicateFlag = this.modalMode === 'add' ? this.fetchMsspFlag(this.msspModalObject.MSSPname) : false;
    const stateFlag = (((this.msspModalObject.country === 'US') || this.msspModalObject.country === 'CA')) ? this.msspModalObject.state !== '' : this.msspModalObject.province !== '';
    flag = (this.msspModalObject.MSSPname !== '') && (this.msspModalObject.emailAddress !== '') && (this.msspModalObject.firstName !== '') && (this.msspModalObject.lastName !== '')
     && (this.msspModalObject.companyName !== '') && (this.msspModalObject.streetAddress !== '') && (this.msspModalObject.city !== '') && (this.msspModalObject.phoneNumber !== '')
      && (this.msspModalObject.country !== '') && stateFlag && (this.msspModalObject.zipCode !== '') && !msspDuplicateFlag && !this.inValidPhone;
    return flag;
  }

  async onSave() {
    this.showErrorMsg = true;
    if (this.getValidationFlag) {
      this.addressType = 'save';
      this.addressVerificationNeeded = '';
      try {
        this.$store.commit('startLoading');
        if (this.modalMode === 'add') {
          await this.addMSSPApiCall();
        } else {
          await this.editMSSPApiCall();
        }
        if ((this.addressVerificationNeeded !== '') && (this.addressVerificationNeeded !== 'MSWAPP:ADDRESSVERIFICATIONNOTNEEDED') && (this.addressVerificationNeeded !== 'MSWAPP:VALIDADDRESS')
          && (this.addressVerificationNeeded !== 'MSWAPP:ADDUSERFAILURE') && (this.addressVerificationNeeded !== 'MSWAPP:SUCCESS')) {
          await this.processAddressVerification();
        } else {
          if ((this.addressVerificationNeeded === 'MSWAPP:ADDRESSVERIFICATIONNOTNEEDED') || (this.addressVerificationNeeded === 'MSWAPP:VALIDADDRESS') || (this.addressVerificationNeeded === 'MSWAPP:SUCCESS')) {
            if (this.modalMode === 'add') {
              await this.addMSSPApiCall();
            } else {
              // await this.editMSSPApiCall();
            }
            this.$emit('onSaveCloseMsspModal');
          }
          if (this.addressVerificationNeeded === 'MSWAPP:ADDUSERFAILURE') {
            this.onBackFn();
          }
        }
        this.$store.commit('stopLoading');
      } catch {
        this.$store.commit('stopLoading');
      }
    }
  }

  async onNext() {
    this.showErrorMsg = true;
    if (this.getValidationFlag) {
      this.addressType = 'next';
      this.addressVerificationNeeded = '';
      this.$store.commit('startLoading');
      try {
        if (this.modalMode === 'add') {
          await this.addMSSPApiCall();
        } else {
          await this.editMSSPApiCall();
        }
        if ((this.addressVerificationNeeded !== '') && (this.addressVerificationNeeded !== 'MSWAPP:ADDRESSVERIFICATIONNOTNEEDED')  && (this.addressVerificationNeeded !== 'MSWAPP:VALIDADDRESS')
        && (this.addressVerificationNeeded !== 'MSWAPP:ADDUSERFAILURE') && (this.addressVerificationNeeded !== 'MSWAPP:SUCCESS')) {
          await this.processAddressVerification();
        } else {
          if ((this.addressVerificationNeeded === 'MSWAPP:ADDRESSVERIFICATIONNOTNEEDED') || (this.addressVerificationNeeded === 'MSWAPP:VALIDADDRESS') || (this.addressVerificationNeeded === 'MSWAPP:SUCCESS')) {
            if (this.modalMode === 'add') {
              await this.addMSSPApiCall();
            } else {
              await this.editMSSPApiCall();
            }
          }
          if (this.addressVerificationNeeded === 'MSWAPP:ADDUSERFAILURE') {
            this.onBackFn();
          }
        }
        if (this.addressVerificationNeeded === 'MSWAPP:ADDMSSPUSERSUCCESS') {
          this.$emit('onSaveCloseMsspModal');
        }
        if (this.addressVerificationNeeded === 'MSWAPP:ADDEXISTINGMSSPUSERSUCCESS') {
          this.$emit('nextTenantClick');
        }
        this.$store.commit('stopLoading');
      } catch {
        this.$store.commit('stopLoading');
      }
    }
  }

  resetAddress() {
    this.addressFormAppliedObj = {
      addressLine1: '',
      addressLine2: '',
      addressLine3: '',
      city: '',
      country: '',
      state: '',
      postalCode: '',
      province: '',
      countryLabel: '',
      stateLabel: '',
    };
    this.addressFormSuggestedObj = {
      addressLine1: '',
      addressLine2: '',
      addressLine3: '',
      city: '',
      country: '',
      state: '',
      postalCode: '',
      province: '',
      countryLabel: '',
      stateLabel: '',
    };
  }
  processAddressVerification() {
    return new Promise((res) => {
      Object.assign(this.addressFormAppliedObj, {
        addressLine1: this.msspModalObject.streetAddress,
        addressLine2: '',
        addressLine3: '',
        city: this.msspModalObject.city,
        country: this.msspModalObject.country,
        state: this.msspModalObject.state || '',
        countryLabel: this.fetchCountryName(this.msspModalObject.country),
        stateLabel: this.fetchStateName(this.msspModalObject.state || ''),
        postalCode: this.msspModalObject.zipCode,
        province: this.msspModalObject.province,
      });
      this.enableAddressVerificationFormModal = true;
      res(true);
    });
  }
  editMSSPApiCall() {
    this.apiFailedAddressVerificationMesssage = '';
    return new Promise((res, rej) => {
      const editMssp: MsspModalObjectEditApi = {
        companyName: this.msspModalObject.companyName,
        emailAddress: this.msspModalObject.emailAddress,
        address: this.msspModalObject.streetAddress,
        city: this.msspModalObject.city,
        state: this.msspModalObject.state,
        zipcode: this.msspModalObject.zipCode,
        country: this.msspModalObject.country,
        phoneNumber: this.msspModalObject.phoneNumber,
        province: this.msspModalObject.province,
        masterMSSPId: this.msspModalObject.MSSPID,
        msspName: this.msspModalObject.MSSPname,
        isDefaultGroup: this.msspModalObject.isDefaultGroup,
        skipAddressValidation: 'NO',
        firstName: this.msspModalObject.firstName,
        lastName: this.msspModalObject.lastName,
        msspNumber: this.msspModalObject.msspNumber,
        msspContractid: this.msspModalObject.msspContractid,
      };
      if (this.addressVerificationEnabled) {
        editMssp.skipAddressValidation = 'YES';
      }
      return MswApiService.tenant.editMssp(editMssp)
      .then((resp: any) => {
        if (resp.operationStatus === 'OK') {
          if (this.addressVerificationEnabled) {
            if ((this.addressVerificationNeeded === 'MSWAPP:INVALIDADDRESS')) {
              if ((resp.msgCode !== 'MSWAPP:ADDMSSPUSERSUCCESS') && (resp.msgCode !== 'MSWAPP:ADDEXISTINGMSSPUSERSUCCESS') && (resp.msgCode !== 'MSWAPP:SUCCESS')) {
                this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
                this.onBackFn();
              } else {
                this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
              }
            } else {
              this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
            }
          } else {
            this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
          }
          this.addressVerificationEnabled = true;
          // this.msspModalObject.MSSPID = resp.MSSPID || '';
          const suggestedAddress = resp.suggestedAddress || {};
          this.addressFormSuggestedObj = {
            addressLine1: suggestedAddress.addressLine || '',
            addressLine2: '',
            addressLine3: '',
            city: suggestedAddress.city || '',
            country: suggestedAddress.country || '',
            state: suggestedAddress.stateCode || '',
            postalCode: suggestedAddress.zipCode || '',
            province: suggestedAddress.province || '',
            countryLabel: this.fetchCountryName(suggestedAddress.country),
            stateLabel: this.fetchStateName(suggestedAddress.stateCode || ''),
          };
          this.addressVerificationNeeded = resp.msgCode;
          this.addressVerificationMsg = resp.msgDesc !== 'Success' ? resp.msgDesc : '';
          this.$store.commit('TenantManagementStoreModule/setNewMsspModalObject', { newMsspModalObject: this.msspModalObject });
        } else {
          this.apiFailedAddressVerificationMesssage = 'failed';
          this.addressVerificationNeeded = '';
          this.addressVerificationEnabled = false;
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
          rej(false);
        }
        res(resp);
      })
      .catch((err: any): any => {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: err.msgDesc });
        rej(false);
      });
    });
  }

  fetchStateName(id: string): string {
    const filteredObj = this.stateOptions.filter((ele: SelectOption) => ele.id === id)[0];
    const filteredName: string = filteredObj ? filteredObj.label.toString() : '';
    return filteredName;
  }

  fetchCountryName(id: string): string {
    const filteredObj = this.countryOptions.filter((ele: SelectOption) => ele.id === id)[0];
    const filteredName: string = filteredObj ? filteredObj.label.toString() : '';
    return filteredName;
  }

  addMSSPApiCall() {
    this.apiFailedAddressVerificationMesssage = '';
    return new Promise((res, rej) => {
      const addMssp: MsspModalObjectAddApi = {
        companyName: this.msspModalObject.companyName,
        firstName: this.msspModalObject.firstName,
        lastName: this.msspModalObject.lastName,
        emailAddress: this.msspModalObject.emailAddress,
        address: this.msspModalObject.streetAddress,
        city: this.msspModalObject.city,
        state: this.msspModalObject.state,
        zipCode: this.msspModalObject.zipCode,
        country: this.msspModalObject.country,
        phoneNumber: this.msspModalObject.phoneNumber,
        province: this.msspModalObject.province,
        msspName: this.msspModalObject.MSSPname,
        isDefaultGroup: 'YES',
        contactTypeId: '10015',
        bskipResellerCustomerValidation: true,
        skipAddressValidation: 'NO',
        msspNumber: this.msspModalObject.msspNumber,
        msspContractid: this.msspModalObject.msspContractid,
      };
      if (this.addressVerificationEnabled) {
        addMssp.skipAddressValidation = 'YES';
      }
      return MswApiService.tenant.addMssp(addMssp)
      .then((resp: any) => {
        if (resp.operationStatus === 'OK') {
          if (this.addressVerificationEnabled) {
            if ((this.addressVerificationNeeded === 'MSWAPP:INVALIDADDRESS')) {
              if ((resp.msgCode !== 'MSWAPP:ADDMSSPUSERSUCCESS') && (resp.msgCode !== 'MSWAPP:ADDEXISTINGMSSPUSERSUCCESS')) {
                this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
                this.onBackFn();
              } else {
                this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
              }
            } else {
              this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
            }
          }
          this.addressVerificationEnabled = true;
          this.msspModalObject.MSSPID = resp.masterMsspId || '';
          this.addressVerificationNeeded = resp.msgCode;
          this.addressVerificationMsg = resp.msgDesc !== 'Success' ? resp.msgDesc : '';
          const suggestedAddress = resp.addressResp || {};
          this.addressFormSuggestedObj = {
            addressLine1: suggestedAddress.address || '',
            addressLine2: '',
            addressLine3: '',
            city: suggestedAddress.city || '',
            country: suggestedAddress.country || '',
            state: suggestedAddress.stateCode || '',
            countryLabel: this.fetchCountryName(suggestedAddress.country),
            stateLabel: this.fetchStateName(suggestedAddress.stateCode || ''),
            postalCode: suggestedAddress.zipCode || '',
            province: suggestedAddress.province || '',
          };
          this.$store.commit('TenantManagementStoreModule/setNewMsspModalObject', { newMsspModalObject: this.msspModalObject });
          res(true);
        } else {
          this.apiFailedAddressVerificationMesssage = 'failed';
          this.addressVerificationNeeded = '';
          this.addressVerificationEnabled = false;
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
          rej(false);
        }
      });
      // .catch((err: any): any => {
        // this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: err.msgDesc });
        // rej(false);
      // });
    });
  }

  resetModalValues() {
    this.addressVerificationEnabled = false;
    this.msspModalObject = {
      MSSPname: '',
      emailAddress: '',
      contactName: '',
      companyName: '',
      phoneNumber: '',
      streetAddress: '',
      city: '',
      country: '',
      state: '',
      zipCode: '',
      isDefaultGroup: 'YES',
      province: '',
      additionalComments: '',
      MSSPID: '',
      firstName: '',
      lastName: '',
      msspNumber: '',
      msspContractid: '',
    };
  }

  get getMsspNewModaLObject() {
    return this.$store.getters['TenantManagementStoreModule/getNewMsspModalObject'];
  }

  onCloseAddressFormModal() {
    this.enableAddressVerificationFormModal = false;
  }

  onBackFn() {
    this.addressVerificationEnabled = false;
    this.enableAddressVerificationFormModal = false;
  }

  async onUseSuggestedAddressFn() {
    // if ((this.addressVerificationNeeded === 'MSWAPP:INVALIDADDRESS')) {
    //   this.onBackFn();
    // } else {
    // }
    try {
      this.$store.commit('startLoading');
      this.msspModalObject.streetAddress = this.addressFormSuggestedObj.addressLine1;
      this.msspModalObject.city = this.addressFormSuggestedObj.city;
      this.msspModalObject.state = this.addressFormSuggestedObj.state;
      this.msspModalObject.country = this.addressFormSuggestedObj.country;
      this.msspModalObject.zipCode = this.addressFormSuggestedObj.postalCode;
      if (this.modalMode === 'add') {
        await this.addMSSPApiCall();
      } else {
        await this.editMSSPApiCall();
      }
      if (this.addressVerificationNeeded === 'MSWAPP:INVALIDADDRESS') {
        this.processAddressVerification();
      } else if (this.apiFailedAddressVerificationMesssage === 'failed') {
        this.onBackFn();
      } else if (this.addressVerificationNeeded === 'MSWAPP:ADDMSSPUSERSUCCESS') {
        this.$emit('onSaveCloseMsspModal');
      } else if (this.addressType === 'save') {
        this.$emit('onSaveCloseMsspModal');
      } else {
        this.$emit('nextTenantClick');
      }
      this.$store.commit('stopLoading');
    } catch {
      if (this.apiFailedAddressVerificationMesssage === 'failed') {
        this.onBackFn();
      }
      this.$store.commit('stopLoading');
    }
  }

  async onUseAppliedAddressFn() {
    // if ((this.addressVerificationNeeded === 'MSWAPP:INVALIDADDRESS')) {
    //   this.onBackFn();
    // } else {
    // }
    try {
      this.$store.commit('startLoading');
      if (this.modalMode === 'add') {
        await this.addMSSPApiCall();
      } else {
        await this.editMSSPApiCall();
      }
      if (this.addressVerificationNeeded === 'MSWAPP:INVALIDADDRESS') {
        this.processAddressVerification();
      } else if (this.apiFailedAddressVerificationMesssage === 'failed') {
        this.onBackFn();
      } else if (this.addressVerificationNeeded === 'MSWAPP:ADDMSSPUSERSUCCESS') {
        this.$emit('onSaveCloseMsspModal');
      } else if (this.addressType === 'save') {
        this.$emit('onSaveCloseMsspModal');
      } else {
        this.$emit('nextTenantClick');
      }
      this.$store.commit('stopLoading');
    } catch {
      if (this.apiFailedAddressVerificationMesssage === 'failed') {
        this.onBackFn();
      }
      this.$store.commit('stopLoading');
    }
  }

  loadMsspDetails() {
    return new Promise((res) => {
      MswApiService.tenant.getMsspFormDetails(this.getMsspNewModaLObject.MSSPID)
      .then((resp: MSSPDetailsApiResponse) => {
        if (resp.operationStatus === 'NOK') {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
          this.$emit('onSaveCloseMsspModal');
          res(true);
        } else {
          const respContent = resp.content;
          Object.assign(this.msspModalObject, {
            emailAddress:  respContent.emailAddress || '',
            contactName: '',
            companyName: respContent.companyName || '',
            phoneNumber: respContent.phoneNumber || '',
            streetAddress: respContent.address || '',
            city: respContent.city || '',
            country: respContent.country || '',
            state: respContent.state || '',
            zipCode: respContent.zipCode || '',
            isDefaultGroup: respContent.isDefaultGroup || 'YES',
            province: respContent.province || '',
            firstName: respContent.firstName,
            lastName: respContent.lastName,
            msspNumber: respContent.msspNumber,
            msspContractid: respContent.msspContractID,
          });
          res(true);
        }
      })
      .catch((err: any) => {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: err.msgDesc });
        this.$emit('onSaveCloseMsspModal');
        res(true);
      });
    });
  }

  loadCountryStateList() {
    return new Promise((res) => {
      MswApiService.tenant.getCountryStateList()
      .then((resp: any) => {
        this.countryList = resp.content ? resp.content.lstCountries ? resp.content.lstCountries : [] : [];
        res(true);
      })
      .catch((err: any) => {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: err.msgDesc });
        res(true);
      });
    });
  }

  async loadMsspModalDetailsApi() {
    try {
      this.$store.commit('startLoading');
      await this.loadCountryStateList();
      if (this.modalMode !== 'add') {
        await this.loadMsspDetails();
      }
      this.$store.commit('stopLoading');
    } catch {
      this.$store.commit('stopLoading');
    }
  }
  created() {
    this.addressVerificationEnabled = false;
    this.resetAddress();
    this.loadMsspModalDetailsApi();
    // const countryOption = this.countryOptions;
    // this.msspModalObject.countryName = countryOption[0] ? countryOption[0].id : '';
    if (this.getMsspNewModaLObject.MSSPname !== '') {
      Object.assign(this.msspModalObject, {
        MSSPname: this.getMsspNewModaLObject.MSSPname,
        MSSPID: this.getMsspNewModaLObject.MSSPID,
      });
    }
  }
}
